import { RefObject } from 'react';
import { OnNext } from '../types';
import { Interstitial } from './components/interstitial/interstitial';
import { Question } from './components/question/question';
import { SurveyItemProps } from './types';

interface ExtendedSurveyItemProps extends SurveyItemProps {
  onWhyWeAskExpand?: () => void;
  hideWhyWeAsk?: boolean;
  isLoading?: boolean;
  onNext: OnNext;
  questionTitleRef?: RefObject<HTMLDivElement>;
}

export const SurveyItem = ({ surveyItem, onNext, onWhyWeAskExpand, hideWhyWeAsk, isLoading, questionTitleRef }: ExtendedSurveyItemProps) => {
  switch (surveyItem.questionnaireItemKind) {
    case 'question':
      return <Question question={surveyItem} isLoading={isLoading} onWhyWeAskExpand={onWhyWeAskExpand} hideWhyWeAsk={hideWhyWeAsk} questionTitleRef={questionTitleRef} onNext={onNext} />;
    case 'interstitial': {
      return <Interstitial interstitial={surveyItem} onNext={onNext} />;
    }
    default:
      return <div>Survey item type not implemented</div>;
  }
};
